import { FormFieldConfig } from "interfaces/forms";

const formFieldAtleta: FormFieldConfig<any> = {
  nome: {
    name: "nome",
    label: "Nome",
    type: "text",
    errorMsg: "Nome é obrigatório",
  },
  apelido: {
    name: "apelido",
    label: "Apelido",
    type: "text",
  },
  cpf: {
    name: "cpf",
    label: "CPF",
    type: "text",
    errorMsg: "CPF é obrigatório",
    invalidMsg: "CPF deve ter 11 digitos",
  },
  rg: {
    name: "rg",
    label: "RG",
    type: "text",
    errorMsg: "RG é obrigatório",
    invalidMsg: "RG deve ter 9 digitos",
  },
  dataNascimento: {
    name: "dataNascimento",
    label: "Data de Nascimento",
    type: "date",
    errorMsg: "Data de Nascimento é obrigatório",
    invalidMsg: "O campo deve ser uma data",
  },
  sexo: {
    name: "sexo",
    label: "Sexo",
    type: "text",
    errorMsg: "Sexo é campo obrigatório",
  },
  equipe: {
    name: "equipe",
    label: "Equipe",
    type: "text",
  },
  email: {
    name: "email",
    label: "E-mail",
    type: "text",
    errorMsg: "E-mail é campo obrigatório",
    invalidMsg: "Endereço de email invalido.",
  },
  celPhone: {
    name: "celPhone",
    label: "Número Celular",
    type: "text",
    errorMsg: "Número do celular é campo obrigatório",
  },
  telefone: {
    name: "telefone",
    label: "Telefone (Opcional)",
    type: "text",
  },
  nomeEmergencia: {
    name: "nomeEmergencia",
    label: "Nome de Emergencia",
    type: "text",
    errorMsg: "Nome de Emergencia é obrigatório",
  },
  celPhoneEmergencia: {
    name: "celPhoneEmergencia",
    label: "Número Celular",
    type: "text",
    errorMsg: "Número do celular é campo obrigatório",
  },
  parentesco: {
    name: "parentesco",
    label: "Parentesco",
    type: "text",
  },
  planoSaude: {
    name: "planoSaude",
    label: "Plano de Saúde",
    type: "text",
  },
  endereco: {
    name: "endereco",
    label: "Endereço",
    type: "text",
    errorMsg: "Endereço é campo obrigatório",
  },
  numero: {
    name: "numero",
    label: "Numero",
    type: "text",
    errorMsg: "Numero é campo obrigatório",
  },
  cep: {
    name: "cep",
    label: "CEP",
    type: "text",
    errorMsg: "CEP é campo obrigatório",
  },
  bairro: {
    name: "bairro",
    label: "Bairro",
    type: "text",
    errorMsg: "Bairro é campo obrigatório",
  },
  cidade: {
    name: "cidade",
    label: "Cidade",
    type: "text",
    errorMsg: "Cidade é campo obrigatório",
  },
  uf: {
    name: "uf",
    label: "UF",
    type: "text",
    errorMsg: "UF é campo obrigatório",
  },
  complemento: {
    name: "complemento",
    label: "Complemento",
    type: "text",
  },
};

export { formFieldAtleta };
